import React, { useState } from 'react';
import { Star, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { useAuth } from '../../context/AuthContext';
import { reviewsAPI } from '../../services/api';
import { guestPurchaseFor, apiErrorMessage } from '../../utils/guestOrders';

export const ReviewForm = ({ product, onClose, onSubmitted }) => {
  const { user } = useAuth();
  const saved = guestPurchaseFor(product._id);
  const [orderId, setOrderId] = useState(saved?.[0] || '');
  const [token, setToken] = useState(saved?.[1]?.token || '');
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submit = async e => {
    e.preventDefault(); if (busy) return;
    setBusy(true); setError('');
    try {
      await reviewsAPI.create(product._id, { rating, comment: comment.trim(), ...(!user || orderId ? { order_id: orderId } : {}) }, token);
      onSubmitted();
    } catch (err) { setError(apiErrorMessage(err)); } finally { setBusy(false); }
  };
  return <Dialog open onOpenChange={open => { if (!open && !busy) onClose(); }}>
    <DialogContent data-testid="review-form-modal" className="max-w-lg w-[calc(100%-2rem)] max-h-[90dvh] overflow-y-auto">
      <DialogTitle>Escribir una reseña</DialogTitle>
      <DialogDescription>{product.title} · Solo compras con pago confirmado.</DialogDescription>
      <form onSubmit={submit} className="space-y-4">
        {!user && <div className="space-y-3">
          <div><Label htmlFor="review-order">Número de pedido completo</Label><Input id="review-order" required value={orderId} onChange={e => setOrderId(e.target.value.trim())} data-testid="review-order-id" /></div>
          <div><Label htmlFor="review-key">Clave privada del pedido</Label><Input id="review-key" type="password" required value={token} onChange={e => setToken(e.target.value.trim())} data-testid="review-guest-key" /></div>
        </div>}
        <fieldset><legend className="text-sm font-medium mb-2">Tu calificación</legend>
          <div className="flex gap-1" role="radiogroup" aria-label="Calificación de 1 a 5">
            {[1, 2, 3, 4, 5].map(n => <button key={n} type="button" role="radio" aria-checked={rating === n} aria-label={`${n} ${n === 1 ? 'estrella' : 'estrellas'}`} data-testid={`review-star-${n}`} onClick={() => setRating(n)} className="p-2 rounded-md hover:bg-amber-50 focus-visible:outline-orange-500 transition-colors"><Star className={`w-7 h-7 ${n <= rating ? 'text-amber-500 fill-amber-400' : 'text-gray-300'}`} /></button>)}
          </div>
        </fieldset>
        <div><Label htmlFor="review-comment">Tu experiencia</Label><Textarea id="review-comment" value={comment} onChange={e => setComment(e.target.value)} required minLength={3} maxLength={2000} rows={4} placeholder="¿Qué te pareció el producto?" data-testid="review-comment" /></div>
        <p className="text-xs text-gray-500" data-testid="review-moderation-notice">Tu reseña se publicará después de ser revisada.</p>
        {error && <p role="alert" className="text-sm text-red-700" data-testid="review-error">{error}</p>}
        <div className="flex justify-end gap-2"><Button type="button" variant="outline" disabled={busy} onClick={onClose} data-testid="review-cancel">Cancelar</Button>
          <Button disabled={busy || !rating || comment.trim().length < 3} className="bg-orange-500 hover:bg-orange-600" data-testid="review-submit">{busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Enviar reseña</Button></div>
      </form>
    </DialogContent>
  </Dialog>;
};